import script from "./HandlerShareDownload.vue?vue&type=script&setup=true&lang=js"
export * from "./HandlerShareDownload.vue?vue&type=script&setup=true&lang=js"

import "./HandlerShareDownload.vue?vue&type=style&index=0&id=174a643c&lang=scss"

const __exports__ = script;

export default __exports__